import { TextField } from '@mui/material';
import styled from 'styled-components';

export const FormTextInput = styled(TextField)({
  '& .MuiFormHelperText-root': {
    color: 'red',
    marginLeft: '2px'
  }
});
